import { EntityProfileHeaderTitleToggleButton } from '../../Entity'
import { MultipleViewTypeListActiveItemPreviewCloseButton } from '../MultipleViewTypeListActiveItemPreviewCloseButton'

function MultipleViewTypeListActiveItemPreviewHeaderToggle({
  closeButtonProps,
  height,
  onClosePreview,
  ...toggleProps
}) {
  return (
    <>
      <EntityProfileHeaderTitleToggleButton {...toggleProps} height={height} />
      <MultipleViewTypeListActiveItemPreviewCloseButton
        {...closeButtonProps}
        height={height}
        onClose={onClosePreview}
      />
    </>
  )
}

export default MultipleViewTypeListActiveItemPreviewHeaderToggle
